import { User } from "model/user";

// Who sees what on the Display page. The page and its quick-search entry both read these, so a
// client can always find the fields it's allowed to edit.

/** v10 hex colour picker and Theme. Detail-only v10 keeps the v9 colour control it had before. */
export function isV10Display(user: User): boolean {
	return !!(user.permissions.kestrelAll && user.kestrelVersion.all);
}

/**
 * IDX Stylesheet and IDX Content, for any v10 layout, Detail Pages Only included: both still reach
 * Kestrel's detail pages, and the old CSS page offered them there. Hidden for WordPress, because
 * Optima Express keeps its own copy of these fields and overwrites ours whenever the plugin
 * registers (css-oidx-panels.md).
 */
export function showIdxCode(user: User): boolean {
	return !!((user.kestrelVersion.all || user.kestrelVersion.detail) && !user.websitePlatform.wordpress);
}

/**
 * Page Head, for standalone clients as before. Dropped on the v10 page, because cssOverride never
 * reaches a v10 client's own site.
 */
export function showPageHead(user: User): boolean {
	return !isV10Display(user) && !!user.permissions.standalone;
}

/**
 * Admins only, as on main, where the nav required admin on every path to /settings/version and
 * /settings/css. Within that, listingDetail is the gate the colour and theme controls had on
 * /settings/version. The code sections widen it, because this page is now the only place to edit
 * them and the old CSS page admitted every standalone client. The page, the sidebar and quick
 * search all read this alone.
 */
export function displayPermitted(user: User): boolean {
	return !!user.admin && (!!user.permissions.listingDetail || showIdxCode(user) || showPageHead(user));
}
